import { styled as o, css as r } from "styled-components";
import { MediaQuery as e } from "../../../styles/variables.js";
import { DealVoteButton as a } from "../DealVoteButton/index.js";
import { Icon as c } from "../../../components/Icon/index.js";
import { SmallLight as s, CaptionHeavy as m } from "../../../styles/typography/index.js";
import { Colors as p } from "../../../styles/colors/index.js";
import { Theme as t } from "../../../styles/themes/index.js";
import { TextSkeleton as n } from "../../../components/TextSkeleton/index.js";
const B = o.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  min-width: max-content;
  color: rgb(${t.colors.Alpha});
  margin-bottom: 20px;

  &[aria-disabled='true'] {
    color: rgb(${t.colors.Golf});
  }

  @media ${e.SCREEN_MD_UP} {
    column-gap: 8px;
    justify-content: center;
    margin-bottom: 0;
  }
`, S = o.span`
  ${s}
  color: rgb(${t.colors.Alpha});
`, d = r`
  flex-direction: column;
  height: auto;
  align-items: center;
  justify-content: flex-end;
`, k = r`
  ${m}
  border: 1px solid rgb(${t.colors.Golf});
  margin-bottom: 4px;
  height: 40px;
  border-radius: 24px;
  background-color: rgb(${t.colors.Juliet});

  &:hover {
    background-color: rgb(${t.colors.Kilo});
  }
`, i = o.div`
  ${d}
  display: flex;
`, A = o(c)`
  color: rgb(${t.colors.Brand});

  &[data-inactive='true'] {
    color: rgb(${p.Gray});
  }
`, l = o(n)`
  display: flex;
  flex-shrink: 0;
  margin-bottom: 4px;
  width: 40px;
  height: 40px;
  border-radius: 24px;
`, D = o(a)`
  background-color: rgb(${t.colors.Juliet});
  margin-bottom: 4px;
  height: 40px;
`, v = o(l)`
  width: 70px;
`, C = o(l)`
  width: 102px;
`, E = o(i)`
  display: none;
  @media ${e.SCREEN_MD_UP} {
    display: flex;
  }
`, I = o(i)`
  display: none;
  @media ${e.SCREEN_MD_UP} {
    display: flex;
  }
`, _ = o(n)`
  height: 48px;
`;
export {
  S as DealActionBarCaption,
  B as DealActionBarContainer,
  A as DealActionBarIcon,
  i as DealActionBarItem,
  E as DealActionBarItemSaved,
  D as DealActionBarVoteButton,
  v as SkeletonCommentLink,
  l as SkeletonLink,
  I as SkeletonSaveButton,
  _ as SkeletonSaveButtonMobile,
  C as SkeletonVoteButton,
  k as dealActionItemStyle
};
